// extracted by css-extract-rspack-plugin
export default {"join":"JoinUsButton-module__join--nMpc2"};